import { FetchResponse } from '@cian/http-api';
import { HttpBadStatusCodeError, UnknownError } from '@cian/peperrors/shared';

import { fetchAddToComparison } from '../../repositories/property-comparison/v1/add-to-comparison';
import { EPropertyType } from '../../repositories/property-comparison/entities/v1_add_to_comparison/AddToComparisonRequest';
import { TAddToComparisonResponse } from '../../repositories/property-comparison/v1/add-to-comparison/types';
import { IComparisonActionResult, IComparisonRequestParams } from './types';

const DOMAIN = 'src/shared/api/comparison/addNewbuildingToComparison';

export async function addNewbuildingToComparison({
  httpApi,
  logger,
  newbuildingId,
}: IComparisonRequestParams): Promise<IComparisonActionResult> {
  let result: FetchResponse<TAddToComparisonResponse>;

  try {
    result = (await fetchAddToComparison({
      httpApi,
      parameters: {
        propertyType: EPropertyType.Newbuilding,
        propertyId: newbuildingId,
      },
    })) as FetchResponse<TAddToComparisonResponse>;
  } catch (error) {
    logger.error(
      new UnknownError({
        message: 'Ошибка при добавлении ЖК в сравнение',
        domain: DOMAIN,
        details: error as UnknownError,
      }),
    );

    throw error;
  }

  const { statusCode, response } = result;
  const responseData = response as IComparisonActionResult;

  if (statusCode !== 200) {
    const error = new HttpBadStatusCodeError({
      statusCode,
      message: responseData.message || responseData.text || 'Ошибка при добавлении ЖК в сравнение',
      domain: DOMAIN,
    });

    logger.error(error);

    throw error;
  }

  return responseData;
}
